import React, { useRef } from "react";
// Styles
import styled from "styled-components";
// State
import PropTypes from "prop-types";
// Components
import { Element } from "react-scroll";
import { Col, Container, Row } from "react-bootstrap";
import Title from "./Title";


// #region styled-components
const StyledAboutMe = styled.section`
  p {
    font-size: 1.25rem;
  }
  
  .profile-image-container {
    position: relative;
    width: 15rem;
    height: 15rem;
    border-radius: 50%;
    perspective: 500px;
  }

  .profile-image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform 0.1s ease;
  }

  .profile-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid var(--bs-primary);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
`;
// #endregion

// #region component
const propTypes = {
  avatar_url: PropTypes.string.isRequired,
  moreInfo: PropTypes.string,
};

const AboutMe = ({ avatar_url, moreInfo }) => {
  const imageWrapperRef = useRef(null);

  const handleMouseMove = (e) => {
    if (imageWrapperRef.current) {
      const rect = imageWrapperRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      
      // Calculate the distance from the center
      const distance = Math.sqrt(x * x + y * y);
      const maxDistance = rect.width / 2;
      
      // Only apply effect if mouse is close to the image
      if (distance < maxDistance) {
        // Calculate rotation angles
        const rotateX = (y / maxDistance) * 10; // Max 10 degrees rotation
        const rotateY = -(x / maxDistance) * 10;
        
        // Calculate push effect (z-translation)
        const pushZ = Math.max(0, (1 - distance / maxDistance) * 10);
        
        imageWrapperRef.current.style.transform = 
          `rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(-${pushZ}px)`;
      } else {
        // Reset transform when mouse is far
        imageWrapperRef.current.style.transform = 'none';
      }
    }
  };

  const handleMouseLeave = () => {
    if (imageWrapperRef.current) {
      imageWrapperRef.current.style.transform = 'none';
    }
  };

  return (
    <Element name={"About"} id="about">
      <StyledAboutMe className="section">
        <Container>
          <Container className="d-flex justify-content-center">
            <Title size={"h2"} text={"About Me"} />
          </Container>
          <Row className="align-items-center mt-5">
            <Col className="d-flex flex-column text-center">
              <Container>
                {moreInfo && moreInfo.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </Container>
            </Col>
            <Col className="d-none d-md-block text-center">
              <div 
                className="profile-image-container mx-auto" 
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
              >
                <div className="profile-image-wrapper" ref={imageWrapperRef}>
                  <img
                    src={require("../images/profile-pic.jpeg")}
                    alt="Profile"
                    loading="lazy"
                    className="profile-image"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </StyledAboutMe>
    </Element>
  );
};

AboutMe.propTypes = propTypes;
// #endregion

export default AboutMe;
